import type * as React from 'react';
import type { InputRef } from 'antd/lib/input';
import { InternalInput } from './Input';
import { Group } from './Group';
import { Search } from './Search';
import { TextArea } from './TextArea';
import { Password } from './Password';

import type { IInputProps } from './Input';
import type { IInputGroupProps } from './Group';
import type { IInputSearchProps } from './Search';
import type { IInputTextAreaProps } from './TextArea';
import type { IInputPasswordProps } from './Password';

type InputStatus = '' | 'error' | 'warning';

interface CompoundedComponent
  extends React.ForwardRefExoticComponent<
    IInputProps & React.RefAttributes<InputRef>
  > {
  Group: typeof Group;
  Search: typeof Search;
  TextArea: typeof TextArea;
  Password: typeof Password;
}

const Input = InternalInput as CompoundedComponent;

Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;

export {
  Input,
  InputRef,
  IInputProps,
  InputStatus,
  IInputGroupProps,
  IInputSearchProps,
  IInputTextAreaProps,
  IInputPasswordProps,
};
